/* eslint-disable import/prefer-default-export */
import ReactSelect from 'react-select';
import styled, { css } from 'styled-components';

export const StyledSelect = styled(ReactSelect)`
  .Select-value-label, .Select-option {
    color: ${(props) => css`${props.styled && props.styled.color} !important`}
  }
`;
